import type { CannedWorkPackageStatus, ReviewStatus } from "@common/client"
import {
  StatusGlyph,
  type StatusKind,
} from "@/routes/_layout/quotes/-components/status-glyphs"
import { reviewStatusLabel } from "../-lib/filters"
import { quoteStatusLabel } from "../-lib/quote-list"

const REVIEW_KIND: Record<ReviewStatus, StatusKind> = {
  approved: "verified",
  pending: "draft",
  rejected: "failed",
}

const QUOTE_STATUS_KIND: Record<CannedWorkPackageStatus, StatusKind> = {
  approved: "verified",
  in_progress: "in_progress",
  draft: "draft",
}

export function QuoteStatusIcon({
  status,
}: {
  status: CannedWorkPackageStatus
}): React.ReactElement {
  return (
    <StatusGlyph
      kind={QUOTE_STATUS_KIND[status]}
      label={quoteStatusLabel(status)}
    />
  )
}

export function ReviewStatusIcon({
  status,
}: {
  status: ReviewStatus
}): React.ReactElement {
  return (
    <StatusGlyph kind={REVIEW_KIND[status]} label={reviewStatusLabel(status)} />
  )
}
